import { useWindowDimensions } from "react-native";
import useMediaQuery from "./use-media-query";

const initialBreakpoints = {
  base: 0,
  sm: 743,
  md: 1023,
  lg: 1279,
  xl: 1439,
};

function useResponsiveWidth() {
  const { width } = useWindowDimensions();
  const RESPONSIVE_WIDTH = [
    width,
    328 + 24,
    468 + 24,
    374 + 56,
    428 + 56,
  ];
  const { mQ } = useMediaQuery(initialBreakpoints);

  return mQ(RESPONSIVE_WIDTH) as number;
}

export default useResponsiveWidth;
